import TextTag from "../../components/Tag";
import "./index.css";

const SECTIONS = [
  {
    id: "collected",
    title: "What data is collected",
    content: `Habitime does not collect any personal data. The only information the app stores are the activities you create, the sessions you log, and your preferences — all of which live exclusively on your device. We have no access to any of it.`,
  },
  {
    id: "storage",
    title: "How data is stored",
    content: `Everything you enter into Habitime is saved locally on your device using on-device storage. Nothing is transmitted to any server. If you delete the app, your data is deleted with it. There is no backup, no sync, and no cloud — by design.`,
  },
  {
    id: "leaves",
    title: "Nothing leaves your device",
    content: `Habitime has no internet requirement and makes no network requests related to your personal data. Your activity logs, session history, and habit data never leave your device under any circumstance. What you track is yours alone.`,
  },
  {
    id: "third-party",
    title: "Third party sharing",
    content: `We do not share, sell, rent, or trade any user data with third parties — because we don't have any. There are no advertising networks, no data brokers, and no analytics platforms receiving information about you or your usage.`,
  },
  {
    id: "analytics",
    title: "No analytics or tracking",
    content: `Habitime contains no analytics SDKs, no crash reporters that transmit data off-device, and no tracking of any kind. We do not know how often you use the app, which features you use, or anything about your behaviour within it.`,
  },
  {
    id: "license",
    title: "Open source & license",
    content: `Habitime is built transparently. The app makes use of open source libraries, each governed by their respective licenses. Usage of the app is subject to our Terms of Use. By using Habitime, you agree to these terms.`,
  },
  {
    id: "rights",
    title: "Your rights",
    content: `Since all data is stored locally on your device, you have full and complete control over it at all times. You can view, edit, export, or delete your data directly within the app. No request to us is needed — it is already entirely in your hands.`,
  },
  {
    id: "contact",
    title: "Contact",
    content: `If you have any questions about this privacy policy or how Habitime handles data, you can reach us at support@habitime.app. We are happy to clarify anything.`,
  },
];

const PrivacyPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-page__hero">
        <TextTag text="Privacy policy" />
        <h1 className="privacy-page__title">
          Your privacy is not a feature — <span>it's the foundation</span>
        </h1>
        <p className="privacy-page__sub">
          Habitime was built with one rule: your data belongs to you. No
          servers, no tracking, no exceptions. Last updated January 2026.
        </p>
      </div>

      <div className="privacy-page__body">
        <div className="privacy-page__sidebar">
          <div className="privacy-page__nav">
            {SECTIONS.map(({ id, title }) => (
              <a key={id} href={`#${id}`} className="privacy-page__nav-link">
                {title}
              </a>
            ))}
          </div>
        </div>

        <div className="privacy-page__content">
          {SECTIONS.map(({ id, title, content }) => (
            <div key={id} id={id} className="privacy-page__section">
              <h2 className="privacy-page__section-title">{title}</h2>
              <p className="privacy-page__section-body">{content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
